import { render, staticRenderFns } from "./shanxiTrainingInformationSupervisionTabBox.vue?vue&type=template&id=0c9c51a7"
import script from "./shanxiTrainingInformationSupervisionTabBox.vue?vue&type=script&lang=js"
export * from "./shanxiTrainingInformationSupervisionTabBox.vue?vue&type=script&lang=js"
import style0 from "./shanxiTrainingInformationSupervisionTabBox.vue?vue&type=style&index=0&id=0c9c51a7&prod&lang=less"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports